// extracted by mini-css-extract-plugin
var _1 = "Response_bottomControls__73e55";
var _2 = "Response_buttonsRight__01b67";
var _3 = "Response_commandsList__fac12";
var _4 = "Response_controls__9d81d";
var _5 = "Response_errorAlert__dc3ee";
var _6 = "Response_iconWrapper__b01ec";
var _7 = "Response_input__4666f";
var _8 = "Response_loader__ab709";
var _9 = "Response_prompt__31555";
var _a = "Response_promtTextCard__86a58";
var _b = "Response_responseContainer__28273";
var _c = "Response_result__8186a";
var _d = "Response_resultText__62b96";
var _e = "Response_resultTitle__15552";
var _f = "Response_root__f4341";
var _10 = "Response_title__506ff";
export { _1 as "bottomControls", _2 as "buttonsRight", _3 as "commandsList", _4 as "controls", _5 as "errorAlert", _6 as "iconWrapper", _7 as "input", _8 as "loader", _9 as "prompt", _a as "promtTextCard", _b as "responseContainer", _c as "result", _d as "resultText", _e as "resultTitle", _f as "root", _10 as "title" }
